import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 天数 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 天数 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 元 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" % ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 元 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 元 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 元 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 元 ")
const _hoisted_9 = { class: "dialog-footer" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("确认")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_el_dialog, {
      width: "830px",
      title: "配置设置",
      modelValue: _ctx.isDialog,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.isDialog = $event)),
      "close-on-click-modal": false,
      onClose: _ctx.handleCloseDialog
    }, {
      footer: _withCtx(() => [
        _createVNode("span", _hoisted_9, [
          _createVNode(_component_el_button, { onClick: _ctx.handleCloseDialog }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.submitData
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.formData,
          rules: _ctx.rules,
          "label-width": "140px",
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: '配置编号（唯一）',
                      prop: "uuid"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.uuid,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.uuid = $event)),
                          placeholder: '请输入'
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: '套餐标题',
                      prop: "title"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.title,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.title = $event)),
                          placeholder: '请输入'
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: '试用期',
                      prop: "trialPeriod"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.trialPeriod,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.trialPeriod = $event)),
                          style: {"width":"255px"},
                          placeholder: '0-180'
                        }, {
                          append: _withCtx(() => [
                            _hoisted_1
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: '正式期',
                      prop: "formalPeriod"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.formalPeriod,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.formalPeriod = $event)),
                          style: {"width":"255px"},
                          placeholder: '0-3650'
                        }, {
                          append: _withCtx(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: '基础年费',
                      prop: "basicAnnualFee"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.basicAnnualFee,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.basicAnnualFee = $event)),
                          placeholder: '0-999999'
                        }, {
                          append: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "代扣费率",
                      prop: "withholdingRate"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.withholdingRate,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.withholdingRate = $event)),
                          maxlength: "6",
                          placeholder: '0-2之间'
                        }, {
                          append: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: '试用功能版本',
                      prop: "roleId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.roleId,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.roleId = $event)),
                          style: {"width":"255px"},
                          placeholder: "请选择"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.roleId,
                                label: item.roleName,
                                value: item.roleId
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: '描述说明',
                      prop: "description"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.description,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.description = $event)),
                          "show-word-limit": "",
                          type: "textarea",
                          rows: 4,
                          maxlength: 256,
                          placeholder: '请输入',
                          style: {"width":"400px"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: '单车基础扣费/天',
                      prop: "price"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.price,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.price = $event)),
                          maxlength: "6",
                          placeholder: '0-10'
                        }, {
                          append: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "单车基础年费",
                      prop: "carBasicAnnualFee"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.carBasicAnnualFee,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formData.carBasicAnnualFee = $event)),
                          placeholder: '0-100'
                        }, {
                          append: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "单车收费扣费/天",
                      prop: "carChargeDailyFee"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.carChargeDailyFee,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formData.carChargeDailyFee = $event)),
                          maxlength: "6",
                          placeholder: "仅数字"
                        }, {
                          append: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "单车收费年费",
                      prop: "carChargeAnnualFee"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.carChargeAnnualFee,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formData.carChargeAnnualFee = $event)),
                          maxlength: "6",
                          placeholder: '0-100'
                        }, {
                          append: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "新功能版本",
                      prop: "newRoleId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.newRoleId,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formData.newRoleId = $event)),
                          style: {"width":"255px"},
                          placeholder: "请选择"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.roleId,
                                label: item.roleName,
                                value: item.roleId
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "试用结束后",
                      prop: "isCompel"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: _ctx.formData.isCompel,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formData.isCompel = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.isCompelOption, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_radio, {
                                label: item.value,
                                key: index
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"])
  ]))
}